<template>
  <div
    class="tva-dropdown-container"
    v-click-outside="close"
    :style="{
      minWidth: minWidthFixed ? minWidthFixed + 'px' : 'none'
    }"
  >
    <div class="quote" v-if="quote" v-html="quote"></div>
    <div
      :class="['tva-dropdown-button', { open: dropdownOpen }]"
      @click="dropdownOpen = !dropdownOpen"
    >
      <div class="tva-dropdown-button-container">
        <span>{{ selectedEl ? selectedEl[label] : placeholder }}</span>
        <svgicon
          class="actions-navigation-chevron-down"
          icon="actions-navigation-chevron-down"
          width="18"
          height="18"
        ></svgicon>
      </div>
    </div>

    <div
      :class="['tva-dropdown-content', dropdownOpen ? 'open' : '']"
      :style="{
        paddingBottom: dropdownOpen ? itemHeight * content.length + 'px' : 0
      }"
    >
      <ul
        :style="{
          maxHeight: maxHeightFixed ? maxHeightFixed + 'px' : 'none'
        }"
      >
        <li
          v-for="(child, childIndex) in content"
          @click="selectElement(child)"
          :key="childIndex"
          :class="{
            selected: selectedEl && child[value] === selectedEl[value]
          }"
          :style="{ height: itemHeight + 'px' }"
        >
          <span> {{ child[label] }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import "@/compiled-icons/actions-navigation-chevron-down";
import ClickOutside from "vue-click-outside";

export default {
  props: {
    content: {
      default: [
        {
          label: "item 1"
        },
        {
          label: "item 2"
        },
        {
          label: "item 3"
        }
      ]
    },
    quote: { default: null },
    placeholder: { default: "Dropdown Placeholder" },
    maxHeightFixed: { default: null },
    minWidthFixed: { default: 250 },
    itemHeight: { default: 40 },
    value: { default: "label" },
    label: { default: "label" },
    selectedElement: {
      default: null
    }
  },
  data() {
    return {
      selectedEl: this.selectedElement,
      dropdownOpen: false
    };
  },
  methods: {
    selectElement(element) {
      this.$emit("select", element);
      this.selectedEl = element;
      this.dropdownOpen = false;
    },
    close() {
      this.dropdownOpen = false;
    }
  },
  watch: {
    selectedElement(selectedElement) {
      this.selectedEl = selectedElement;
    }
  },
  directives: {
    ClickOutside
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.tva-dropdown-container {
  position: relative;
  display: inline-block;
  z-index: 1;
  user-select: none;
  .quote {
    margin-bottom: 0.5em;
    color: $primary;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
  }
  .tva-dropdown-button {
    width: 100%;
    cursor: pointer;
    display: inline-block;
    height: 40px;
    position: relative;
    background: #fff;
    &-container {
      width: 100%;
      height: 100%;
      padding: 0 8px;
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      span {
        &::first-letter {
          text-transform: uppercase;
        }
      }
      &::after {
        opacity: 0;
        transition: opacity 0.7s ease 0.2s;
        content: "";
        position: absolute;
        bottom: -7px;
        left: 0;
        height: 7px;
        width: 100%;
        background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0));
        z-index: 1;
      }
      &:hover {
        background: rgba($secondary, 0.5);
        color: $primary;
      }
      .svg-icon {
        margin-left: 7px;
        fill: $primary;
        transition: transform 0.5s ease;
      }
    }
    &.open {
      .tva-dropdown-button-container {
        &::after {
          opacity: 1;
        }
        .svg-icon {
          transform: rotate(-180deg);
        }
      }
    }
  }
  .tva-dropdown-content {
    overflow: hidden;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    transition: padding 0.5s ease;
    box-sizing: border-box;
    display: inline-block;
    color: $primary;
    background-color: white;
    cursor: pointer;
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 500;
    ul {
      border: solid 1px $primary;
      position: absolute;
      left: 0;
      bottom: 0;
      list-style-type: none;
      padding: 0;
      margin: 0;
      width: 100%;
      li {
        width: 100%;
        cursor: pointer;
        padding: 3px 8px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &::first-letter {
            text-transform: uppercase;
          }
        }
        &:hover,
        &.selected {
          background: rgba($secondary, 0.5);
          color: $primary;
        }
      }
    }
  }
}
</style>
